module.exports = __webpack_public_path__ + "15656074aab570bd865994f05bf37416.svg";